import axios from "axios";

export default version => {
  return axios.create({
    baseURL: `https://api.nakarta.com/api/${version}`,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
};
